import { render, staticRenderFns } from "./UserAccessControl.vue?vue&type=template&id=22f19584&scoped=true"
import script from "./UserAccessControl.vue?vue&type=script&lang=js"
export * from "./UserAccessControl.vue?vue&type=script&lang=js"
import style0 from "./UserAccessControl.vue?vue&type=style&index=0&id=22f19584&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f19584",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f19584')) {
      api.createRecord('22f19584', component.options)
    } else {
      api.reload('22f19584', component.options)
    }
    module.hot.accept("./UserAccessControl.vue?vue&type=template&id=22f19584&scoped=true", function () {
      api.rerender('22f19584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/UserAccessControl.vue"
export default component.exports